import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, ToastController, App } from 'ionic-angular';
// import { Clipboard } from '@ionic-native/clipboard';
import { HttpService } from '../../services/HttpService';
import { ApplyPage } from '../apply/apply';

import { LoginPage } from '../login/login';
import { WithdrawalPage } from '../withdrawal/withdrawal';

/**
 * Generated class for the CountdownPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-countdown',
  templateUrl: 'countdown.html',
})
export class CountdownPage {
    loginId: string;
	email: string;
	jikgeup: string;
    api_key: string;
    version: string;
    
    d_day: any;
    days: any;
    hours: any;
    minutes: any;
    seconds: any;
    today: any;
    d_day_count: any;
    interest_count: any;
    diff: any;

    date: string;
    coin: string;
    finish: string = '';
    bonus_total: string = '';
    bonus_today: string = '';
    now_bonus: string = '';
    bonus_second: string = '';
    interest_total: string;
    interest_today: string;
    staking_terms: string;
    no_name: string;
    no: string;

    idx: string;
    coin_unit: string;	
	unit: string;
	stock_unit: string;
    
    balance: string;
    value: string;

    texts: any = [];
    language : string;
    
    isButton : boolean = true;

    constructor(
		public navCtrl: NavController,
        public navParams: NavParams,
		public alertCtrl: AlertController,
		public modalCtrl: ModalController,
		public toastCtrl: ToastController,
		// private barcodeScanner: BarcodeScanner,
		// private camera: Camera,
        // private clipboard: Clipboard,
        private http: HttpService,
		public app: App
	) {
		this.idx = navParams.get("idx");
	}

    ionViewDidLoad() {
        
    }

    ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "countdown");
		this.loginId = localStorage.getItem("loginId");
		this.email = localStorage.getItem("email");
		this.jikgeup = localStorage.getItem("jikgeup");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		this.coin_unit = localStorage.getItem("coin_unit");
		this.unit = localStorage.getItem("unit");
        this.stock_unit = localStorage.getItem("stock_unit");

        this._get_texts();

        this._init().then(() => {
			setTimeout(() => {
                this._count_d_day();
                this._interest();
            },500);
		});
	}

    ionViewWillLeave() {
        clearInterval(this.d_day_count);
        clearInterval(this.interest_count);
    }

    _get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).countdown;
	}

    _count_d_day() {
        // const remainTime = document.querySelector("#remain-time");
        let self = this;

        if (self.finish == '') {
            self.d_day = this.texts.count_startM
            return;
        }

        function diffDay() {
            let masTime: any;
            let todayTime: any;
            masTime = new Date(self.finish);
            todayTime = new Date();
            self.today = todayTime;
            
            let diff = masTime - todayTime;
            self.diff = diff;

            if (diff < 0) {
                clearInterval(self.d_day_count);
                self.d_day = this.texts.count_endM
                return;
            }

            let diffDay = String(Math.floor(diff / (1000*60*60*24)));
            let diffHour =String(Math.floor((diff / (1000*60*60)) % 24)).padStart(2,"0");
            let diffMin = String(Math.floor((diff / (1000*60)) % 60)).padStart(2,"0");
            let diffSec = String(Math.floor(diff / 1000 % 60)).padStart(2,"0");
            // let diffMSec = String(Math.floor(diff % 1000)).substr(0, 1);
            
            self.d_day = `${diffDay}일 ${diffHour}시간 ${diffMin}분 ${diffSec}초`;
            self.days = diffDay;
            self.hours = diffHour;
            self.minutes = diffMin;
            self.seconds = diffSec;
        }

        diffDay();
        self.d_day_count = setInterval(diffDay, 1000);
    }

    _interest() {
        let self = this;
        let interest_total: string;
        let interest_today: string;
        let start_interest: boolean = true;
        
        // self.start = '';

        if (self.bonus_total == '') {
            self.interest_total = '0.0000000000';
            self.interest_today = '0.0000000000';
            return;
        }

        function _count_interest() {
            if (self.diff < 0) {
                clearInterval(self.interest_count);
                self.interest_total = self.bonus_total;
                self.interest_today = self.interest_today;
                return;
            }

            if (start_interest) {
                interest_total = (Number(self.bonus_total) + Number(self.bonus_second)).toFixed(10);
                interest_today = (Number(self.bonus_today) + Number(self.bonus_second)).toFixed(10);
                start_interest = false;
            } else {
                interest_total = (Number(interest_total) + Number(self.bonus_second)).toFixed(10);
                interest_today = (Number(interest_today) + Number(self.bonus_second)).toFixed(10);
            }
            let parts_total = interest_total.toString().split(".");
            let parts_today = interest_today.toString().split(".");
            self.interest_total = parts_total[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts_total[1] ? "." + parts_total[1] : "");
            self.interest_today = parts_today[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts_today[1] ? "." + parts_today[1] : "");
            
            // self.interest_total = Number(interest_total).toLocaleString(undefined, {maximumFractionDigits: 6});
            // self.interest_today = Number(interest_today).toLocaleString(undefined, {maximumFractionDigits: 6});
            
        }

        _count_interest();
        self.interest_count = setInterval(_count_interest, 1000);
    }

    _init() {
        return new Promise((resolve,reject)=>{
            let url = "staking/base/index/operate";
            let body = JSON.stringify({ 
                api: this.api_key,
                language: this.language,
                version: this.version,
                idx: this.idx
            });
            this.http.post(url, body).then((res: any) => {
                if(res.result=="OK"){
                    this.idx = res.idx;
                    this.date = res.date;
                    this.value = res.value;
                    // this.coin = res.coin;
                    // this.coin_unit = res.coin_unit;
                    this.finish = res.finish;
                    this.bonus_second = res.bonus_second;
                    // this.bonus_total = res.bonus_total;
                    let bonus_total = res.bonus_total.replace(/[^0-9.]/g, "");
                    this.bonus_total = bonus_total;

                    this.bonus_today = res.bonus_today;
                    let bonus_today = res.bonus_today.replace(/[^0-9.]/g, "");
                    this.bonus_today = bonus_today;

                    this.staking_terms = res.staking_terms;
                    this.no_name = res.no_name;
                    this.no = res.no;
                    resolve(res);
                } else if(res.result ==="DONOT"){
                    let alert = this.alertCtrl.create({
                        message: res.message,
                        buttons: ['OK']
                    });
                    alert.present();
                    this.navCtrl.pop();

                } else if(res.result ==="LOGOUT"){
                    let alert = this.alertCtrl.create({
                        message: res.message,
                        buttons: ['OK']
                    });
                    alert.present();
                    localStorage.removeItem("loginId");
                    localStorage.removeItem("api_key");
                    this.app.getRootNav().setRoot(LoginPage);
                
                } else {
                    this.navCtrl.pop();
                    let alert = this.alertCtrl.create({
                        message: res.message,
                        buttons: ['OK']
                    });
                    alert.present();
                }
            },(err)=>{
                let alert = this.alertCtrl.create({
                    message: this.texts.alertM_err,
                    buttons: ['OK']
                });
                alert.present();
                reject(err);
            });
        });
	}

    _btn_event(event) {
        if (event == 'close') {
            this.navCtrl.pop();
        }

        if (event == 'deposit') {
            this.navCtrl.push(ApplyPage);
        }

        if (event == 'withdrawal') {
            this.navCtrl.push(WithdrawalPage, {from : 'list'});
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/countdown/countdown.ts